import API from './api.js'

export default {

    async uploadFile(type, name, data) {
        try {
            let response = null

            switch (type) {
                case '1-1':
                    response = await API.HTTPS.post('/api/configuration/languages/analyses/' + name + '/upload', data)
                    break

                case '1-2-1':
                    response = await API.HTTPS.post('/api/configuration/emailtemplates/Order/' + name + '/upload', data)
                    break

                case '1-2-2':
                    response = await API.HTTPS.post('/api/configuration/emailtemplates/ResetLink/' + name + '/upload', data)
                    break

                case '1-2-3':
                    response = await API.HTTPS.post('/api/configuration/emailtemplates/ResetPassword/' + name + '/upload', data)
                    break

                case '1-2-4':
                    response = await API.HTTPS.post('/api/configuration/emailtemplates/Sample/' + name + '/upload', data)
                    break

                case '1-3':
                    response = await API.HTTPS.post('/api/configuration/languages/eventscategories/' + name + '/upload', data)
                    break

                case '1-4':
                    response = await API.HTTPS.post('/api/configuration/languages/oiltypes/' + name + '/upload', data)
                    break

                case '1-5':
                    response = await API.HTTPS.post('/api/configuration/languages/ui/' + name + '/upload', data)
                    break

                case '2':
                    response = await API.HTTPS.post('/api/configuration/semaphores/' + name + '/upload', data)
                    break

                case '3':
                    response = await API.HTTPS.post('/api/configuration/sensors/parametersets/upload', data)
                    break
            }

            return { code: 0, data: response }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    }
}